export default __webpack_public_path__ + "static/media/resource-big-bg.d8295bbb4a28acc2a9607450d9ff9281.svg";